import React from "react";
import "./offerReview.scss";
import OfferDetails from "./OfferDetails";

const MobileViews = ({ offerData, merchantData, firstLocation }) => {
  return (
    <div className="flex justify-center items-center w-full max-w-6xl mx-auto">
      <OfferDetails
        offerData={offerData}
        merchantData={merchantData}
        firstLocation={firstLocation}
      />
    </div>
  );
};

export default MobileViews;
